import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import when from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withModel } from '../../data-providers/model';
import CartSummary from './CartSummary';
import { getCart, isCartEmpty } from '../../../store/selectors/cart';
import { getValues } from './helpers';

const enhance = compose(
  withModel,
  formatPrismicData,
  connect(state => ({
    summary: getCart(state),
    isCartEmpty: isCartEmpty(state),
  })),
  when(props => props.isCartEmpty, renderNothing, c => c),
  withProps(props => ({
    paymentIconExclusions: ['apple_pay', 'amazon_pay', 'paypal_checkout'],
    labels: {
      currency: props.currencyLabel,
      itemTotal: props.totalLabel,
      discountCode: props.discountCodeLabel,
      discountAmount: props.discountAmountLabel,
      discountedTotal: props.totalDiscountedLabel,
      estimatedShipping: props.estimatedShippingLabel,
      seeExactCostsLabel: props.seeExactCostsLabel
    },
    values: getValues(props),
  })),
);

export default enhance(CartSummary);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/index.js